const paymentMetadataKeys = [
  'paymentMethodId',
  'paymentProcessorId',
  'paymentProcessorName'
];

const getErrorMessages = errors => {
  if (!Array.isArray(errors)) {
    return [];
  }

  return errors
    .map(error => (typeof error === 'string' ? error : error?.message))
    .filter(message => typeof message === 'string' && message.trim().length > 0)
    .map(message => message.trim());
};

const getSafePaymentMetadata = detail => paymentMetadataKeys.reduce((metadata, key) => {
  const value = detail[key];
  if ((typeof value === 'string' && value.trim().length > 0) || typeof value === 'number') {
    return { ...metadata, [key]: value };
  }
  return metadata;
}, {});

const sanitizeLogMessage = message => message
  .replace(
    /(\b(?:sessionKey|credentials|cardHolderName|cardNumber|cvv|cvc|postcode|postalCode|zip|email|phone|telephone|token|password|authorization)\b\s*["']?\s*[:=]\s*["']?)([^"',;\r\n}]+)(["']?)/gi,
    '$1[REDACTED]$3'
  )
  .replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi, '[REDACTED]');

export const isFreedomPaySessionErrorMessage = message => {
  if (!message || typeof message !== 'string') {
    return false;
  }

  return (
    /Unable to generate payment key/i.test(message) ||
    /sessionKey.*(invalid|expired)/i.test(message) ||
    /\bsession\b.{0,30}\b(invalid|expired)\b/i.test(message) ||
    /\b(invalid|expired)\b.{0,30}\bsession\b/i.test(message)
  );
};

export const paymentErrorFromDetail = detail => {
  if (!detail || typeof detail !== 'object') {
    return null;
  }

  const errors = getErrorMessages(detail.errors);
  if (!errors.length) {
    return null;
  }

  return {
    errors,
    ...getSafePaymentMetadata(detail)
  };
};

export const errorForDatadog = input => {
  if (input instanceof Error) {
    const message = sanitizeLogMessage(input.message.trim());
    if (!message) {
      return null;
    }

    const error = new Error(message);
    Object.assign(error, getSafePaymentMetadata(input));
    return error;
  }

  if (typeof input === 'string') {
    const message = sanitizeLogMessage(input.trim());
    return message ? new Error(message) : null;
  }

  if (!input || typeof input !== 'object') {
    return null;
  }

  const errors = getErrorMessages(input.errors);
  let message = errors.join('; ');
  if (!message && typeof input.message === 'string') {
    message = input.message.trim();
  }

  message = sanitizeLogMessage(message);
  if (!message) {
    return null;
  }

  const error = new Error(message);
  Object.assign(error, getSafePaymentMetadata(input));
  return error;
};
